import { TimeRange } from "sbtech-sports-data-api-client";

export const addHours = (from: Date, hoursToAdd: number) =>
    new Date(
        from.getFullYear(),
        from.getMonth(),
        from.getDate(),
        from.getHours() + hoursToAdd,
        from.getMinutes(),
        from.getSeconds()
    );

export const addDays = (from: Date, daysToAdd: number) =>
    new Date(
        from.getFullYear(),
        from.getMonth(),
        from.getDate() + daysToAdd,
        from.getHours(),
        from.getMinutes(),
        from.getSeconds()
    );

export const DateRangeMapper = {
    [TimeRange.OneHour]: (from: Date) => addHours(from, 1),
    [TimeRange.TwoHours]: (from: Date) => addHours(from, 2),
    [TimeRange.ThreeHours]: (from: Date) => addHours(from, 3),
    [TimeRange.SixHours]: (from: Date) => addHours(from, 6),
    [TimeRange.TwelveHours]: (from: Date) => addHours(from, 12),
    [TimeRange.OneDay]: (from: Date) => addDays(from, 1),
    [TimeRange.TwoDays]: (from: Date) => addDays(from, 2),
    [TimeRange.ThreeDays]: (from: Date) => addDays(from, 3),
    [TimeRange.SevenDays]: (from: Date) => addDays(from, 7)
}
